import { preSalesLaunchRoleIDs, srRoleIDOfUser } from '../constants/srRoleAccess';

// Pre-Sales Launch role lists on Booking Setup. Each blocks only the exact roles HQ picked, so an
// empty or missing list blocks nobody, and HQ and admins are never blocked. Mirrors
// reservationBlocked / salesChartBlocked in book-api, which also refuse on the server.
const roleIsListed = (auth, roleIDs) => {
  const roleID = srRoleIDOfUser(auth);
  return preSalesLaunchRoleIDs.includes(roleID) &&
    Array.isArray(roleIDs) && roleIDs.includes(roleID);
};

// canManagePreSalesLaunch: only HQ and admins may change the lists. Sales Managers and
// Supervisors can save a project too, so the lists are read-only for them, and book-api keeps
// the saved lists whatever they send.
export const canManagePreSalesLaunch = auth => !!auth &&
  !!(auth.isSuperAdmin || auth.isAdmin || auth.isAdminBasic || auth.isHeadquarters);

// reservationBlocked: the user may not open the new booking form, reserve or change unit.
export const reservationBlocked = (auth, project) => (
  !!project && roleIsListed(auth, project.reserveDisabledRoleIDs)
);

// salesChartBlocked: the user does not get the Storey Plan.
export const salesChartBlocked = (auth, project) => (
  !!project && roleIsListed(auth, project.salesChartDisabledRoleIDs)
);



// WEBPACK FOOTER //
// ./src/utils/preSalesLaunch.js